<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Auditoria</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <!-- <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-down"></i></a></li> -->
                  <li>
                    <a
                      v-if="getPermissionFw('auditoria.conferir')"
                      @click="onLiberar()"
                      v-b-tooltip
                      title="Conferir em lote"
                      ><i class="fa fa-search"></i
                    ></a>
                    <a
                      v-if="getPermissionFw('auditoria.aprovar')"
                      @click="onConfirm()"
                      v-b-tooltip
                      title="Confirmação em lote"
                      ><i class="fa fa-check"></i
                    ></a>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('inclusaoocorrencia.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/auditoria"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="doctransp_id"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="auditoria-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="tp_doc" slot-scope="props">
                      {{ props.rowData.liv_tp_doc.descr }}
                    </template>
                    <template slot="vlr_custo_total" slot-scope="props">
                      {{ formatNumber(props.rowData.vlr_calculo) }}
                    </template>
                    <template slot="cte" slot-scope="props">
                      {{ props.rowData.num_doc }}
                    </template>
                    <template slot="vlr_custo" slot-scope="props">
                      {{
                        formatNumber(
                          props.rowData.doc_transp_vlr_prestacao.vlr_receber
                        )
                      }}
                    </template>
                    <template slot="serie" slot-scope="props">
                      {{ props.rowData.serie }}
                    </template>
                    <template slot="emi" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_transp_partes_env.emi_cnpj != null
                        "
                        >{{
                          ajustaMascara(
                            props.rowData.doc_transp_partes_env.emi_cnpj,
                            2
                          )
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.doc_transp_partes_env.emi_cpf != null
                        "
                        >{{
                          ajustaMascara(
                            props.rowData.doc_transp_partes_env.emi_cpf,
                            1
                          )
                        }}</span
                      >
                    </template>
                    <template slot="emi_nome" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_transp_partes_env.emi_nome != null
                        "
                      >
                        {{ props.rowData.doc_transp_partes_env.emi_nome }}
                      </span>
                      <span
                        v-if="
                          props.rowData.doc_transp_partes_env
                            .emi_nome_fantasia != null
                        "
                      >
                        {{
                          props.rowData.doc_transp_partes_env.emi_nome_fantasia
                        }}
                      </span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-warning"
                        v-if="
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit != null &&
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status
                            .valor == 1
                        "
                        >{{
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit != null &&
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status
                            .valor == 2
                        "
                        >{{
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit != null &&
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status
                            .valor == 3
                        "
                        >{{
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status.descr
                        }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit != null &&
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status
                            .valor == 4
                        "
                        >{{
                          props.rowData.auditoria_frete
                            .pedido_unidade_carga_trecho_audit[0].status.descr
                        }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <!-- <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          ><i class="fa fa-edit"></i
                        ></a> -->
                        <a
                          v-if="
                            getPermissionFw('auditoria.conferir') &&
                            props.rowData.auditoria_frete != null &&
                            props.rowData.auditoria_frete.status == 1
                          "
                          @click="onLiberar(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Conferir"
                          ><i class="fa fa-search"></i
                        ></a>
                        <a
                          v-if="
                            getPermissionFw('auditoria.aprovar') &&
                            props.rowData.auditoria_frete != null &&
                            props.rowData.auditoria_frete.status == 3
                          "
                          @click="onConfirm(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Confirmar"
                          ><i class="fa fa-check"></i
                        ></a>
                        <a
                          v-if="
                            (props.rowData.auditoria_frete.status == 1 ||
                              props.rowData.auditoria_frete.status == 3) &&
                            getPermissionFw('auditoria.desassociar')
                          "
                          @click="onDesassociar(props.rowData.doctransp_id)"
                          v-b-tooltip
                          title="Desassociar"
                          ><i class="fa fa-times"></i
                        ></a>

                        <!-- <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a> -->

                        <a
                          v-if="
                            props.rowData.auditoria_frete
                              .pedido_unidade_carga_trecho_audit != null
                          "
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AuditoriaModal ref="auditoriamodal" />
      <AuditoriaConfirmModal ref="auditoriaconfirmmodal" />
      <AuditoriaConfirmDesassociacaoModal
        ref="auditoriaconfirmdesassociacao"
        :metodo="onFilterReset"
      />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import AuditoriaFilterBar from "./AuditoriaFilterBar.vue";
import AuditoriaModal from "./AuditoriaModal.vue";
import AuditoriaDetalhes from "./AuditoriaDetalhes.vue";
import AuditoriaConfirmModal from "./AuditoriaConfirmModal.vue";
import AuditoriaConfirmDesassociacaoModal from "./AuditoriaConfirmDesassociacaoModal.vue";
import accounting from "accounting";

Vue.component("auditoria-detalhes", AuditoriaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    AuditoriaModal,
    AuditoriaConfirmModal,
    AuditoriaConfirmDesassociacaoModal,
    "vuetable-filterbar": AuditoriaFilterBar,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      optionsStatus: [],
      optionsTpTrecho: [],
      optionsTpLiberacao: [],
      doctransp_id: [],
      filter_data_store: {},
      optionsStatusDocTranp: [],
      optionsStatusIntegracao: [],
      optionsStatusAprovar: [],
      optionsParamMotivo: [],
      filtros_form: new Form({
        carga: "",
        num_doc: "",
        num_trecho: "",
        dt_emissao_ini: "",
        dt_emissao_fim: "",
        chave: "",
        status_doc_tranp: "",
        status_integracao: "",
        dt_enviado: "",
        dt_retorno: "",
        dt_auditoria: "",
        status: "",
        tp_doc: "",
        transportadora: "",
        param_motivo: "",
      }),
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      isFullscreen: false,
      form: new Form({ audifre_id: "" }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:tp_doc",
          title: "Tp Documento",
          sortField: "tp_doc",
        },
        {
          name: "__slot:cte",
          title: "N° CTE",
          sortField: "cte",
        },
        {
          name: "__slot:serie",
          title: "Serie",
          sortField: "serie",
        },
        {
          name: "chave",
          title: "Chave",
          sortField: "chave",
        },
        {
          name: "dt_emissao",
          title: "Data de Emissão",
          callback: "formatDate|DD/MM/YYYY",
        },
        {
          name: "__slot:vlr_custo",
          title: "Vlr. documento",
          sortField: "vlr_custo",
        },
        {
          name: "__slot:emi_nome",
          title: "Nome Emitente",
          sortField: "vlr_custo",
        },
        {
          name: "__slot:emi",
          title: "Cnpj/cpf",
        },
        {
          name: "__slot:vlr_custo_total",
          title: "Vlr.Calculo",
          sortField: "vlr_custo_total",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        carga: data_filter.carga,
        num_doc: data_filter.num_doc,
        num_trecho: data_filter.num_trecho,
        dt_emissao_ini: this.formatDateSubmit(data_filter.dt_emissao_ini),
        dt_emissao_fim: this.formatDateSubmit(data_filter.dt_emissao_fim),
        chave: data_filter.chave,
        status_doc_tranp: data_filter.status_doc_tranp.value,
        status_integracao: data_filter.status_integracao.value,
        dt_enviado: this.formatDateSubmit(data_filter.dt_enviado),
        dt_retorno: this.formatDateSubmit(data_filter.dt_retorno),
        dt_auditoria: this.formatDateSubmit(data_filter.dt_auditoria),
        status: data_filter.status.value,
        tp_doc: data_filter.tp_doc.value,
        transportadora: data_filter.transportadora.value,
        param_motivo: data_filter.param_motivo,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      console.log(tipo);
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        console.log("this.filter_data_store");
        console.log(this.filter_data_store);
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.carga = this.filter_data_store.carga;
          this.filtros_form.num_doc = this.filter_data_store.num_doc;
          this.filtros_form.num_trecho = this.filter_data_store.num_trecho;
          this.filtros_form.dt_emissao_ini =
            this.filter_data_store.dt_emissao_ini;
          this.filtros_form.dt_emissao_fim =
            this.filter_data_store.dt_emissao_fim;
          this.filtros_form.chave = this.filter_data_store.chave;
          this.filtros_form.status_doc_tranp =
            this.filter_data_store.status_doc_tranp;
          this.filtros_form.status_integracao =
            this.filter_data_store.status_integracao;
          this.filtros_form.dt_enviado = this.filter_data_store.dt_enviado;
          this.filtros_form.dt_retorno = this.filter_data_store.dt_retorno;
          this.filtros_form.dt_auditoria = this.filter_data_store.dt_auditoria;
          this.filtros_form.status = this.filter_data_store.status;
          this.filtros_form.tp_doc = this.filter_data_store.tp_doc;
          this.filtros_form.transportadora =
            this.filter_data_store.transportadora;
          this.filtros_form.param_motivo = this.filter_data_store.param_motivo;
          this.filtros_form
            .post("/api/auditoria/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj));
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onLiberar(data) {
      if (data == undefined && this.$refs.vuetable.selectedTo.length == 0) {
        this.$snotify.error("Selecione pelo menos um documento");
      } else {
        if (this.$refs.vuetable.selectedTo.length > 0) {
          this.$refs.auditoriamodal.onCreate(this.$refs.vuetable.selectedTo);
        } else {
          this.doctransp_id = [];
          this.doctransp_id.push(data.doctransp_id);
          this.$refs.auditoriamodal.onCreate(this.doctransp_id);
        }
      }
    },
    onConfirm(data) {
      if (data == undefined && this.$refs.vuetable.selectedTo.length == 0) {
        this.$snotify.error("Selecione pelo menos um documento");
      } else {
        if (this.$refs.vuetable.selectedTo.length > 0) {
          this.$refs.auditoriaconfirmmodal.onCreate(
            this.$refs.vuetable.selectedTo
          );
        } else {
          this.doctransp_id = [];
          this.doctransp_id.push(data.doctransp_id);
          this.$refs.auditoriaconfirmmodal.onCreate(this.doctransp_id);
        }
      }
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.doctransp_id);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onCreate() {
      this.$refs.unidadeform.onCreate();
    },
    onEdit(data, index) {
      this.$refs.unidadeform.onEdit(data);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onDesassociar(data) {
      this.$refs.auditoriaconfirmdesassociacao.onCreate(data);
    },
    getLivGeral() {
      this.helpForm
        .get("/api/auditoria/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsStatus.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status_aprovar.forEach((obj) => {
            this.optionsStatusAprovar.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_liberacao.forEach((obj) => {
            this.optionsTpLiberacao.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_doc.forEach((obj) => {
            this.optionsTpTrecho.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status_doc_tranp.forEach((obj) => {
            this.optionsStatusDocTranp.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status_integracao.forEach((obj) => {
            this.optionsStatusIntegracao.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.param_motivo.forEach((obj) => {
            this.optionsParamMotivo.push({
              label: obj.descr,
              value: obj.parmot_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    ajustaMascara(data, tipo) {
      if (tipo === 1) {
        //cpf
        return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (tipo === 2) {
        //cnpj
        return data.replace(
          /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
